export default {
  name: 'dashify:GridContainer',
  title: 'Grid Container (no reflow)',
  owner: 'System',
  solution: '',
  tags: ['layouts', 'grid'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [
      [
        'div',
        {
          '.': '/${ "dark:bg-slate-900 grid grid-cols-12 gap-2 p-3 " & props.className }',
        },
        '/${children}',
      ],
    ],
  },
};
